import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Format, Lock, Text } from '../../..'
import { useCountUp } from 'react-countup'

const defaultProps = {
  locked: false,
}

const propTypes = {
  annualEarnings: PropTypes.number,
  locked: PropTypes.bool,
  monthlyEarnings: PropTypes.number,
}

const FactTable = ({ annualEarnings, locked, monthlyEarnings }) => {
  const {
    countUp: countUpMonthly,
    start: startMonthly,
    update: updateMonthly,
  } = useCountUp({
    start: 0,
    end: monthlyEarnings,
    duration: 1,
  })

  const {
    countUp: countUpYearly,
    start: startYearly,
    update: updateYearly,
  } = useCountUp({
    start: 0,
    end: annualEarnings,
    duration: 1,
  })

  useEffect(() => {
    updateMonthly(monthlyEarnings)
  }, [monthlyEarnings]) // eslint-disable-line

  useEffect(() => {
    updateYearly(annualEarnings)
  }, [annualEarnings]) // eslint-disable-line

  useEffect(() => {
    startMonthly()
    startYearly()
  }, []) // eslint-disable-line

  return (
    <div className='fact-set fact-set--vertical fact-set--vertical--alternate-colors'>
      <div className='fact'>
        <Text
          element='h3'
          className='explanation'
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='AirDna.summary.avgMonthlyRevenue'
            defaultMessage='Avg. Monthly Revenue'
          />
        </Text>
        <Lock enabled={locked}>
          <div className='value'>
            <Text element='span' variant='success' variantCount='700' size='xl'>
              <Format.Currency value={Math.round(countUpMonthly)} />
            </Text>
          </div>
        </Lock>
      </div>
      <div className='fact'>
        <Text
          element='h3'
          className='explanation'
          variant='neutralCool'
          variantCount='700'
        >
          <FormattedMessage
            id='AirDna.summary.annualRevenue'
            defaultMessage='Annual Revenue'
          />
        </Text>
        <Lock enabled={locked}>
          <div className='value'>
            <Text element='span' variant='success' variantCount='700' size='xl'>
              <Format.Currency value={Math.round(countUpYearly)} />
            </Text>
          </div>
        </Lock>
      </div>
    </div>
  )
}

FactTable.defaultProps = defaultProps
FactTable.propTypes = propTypes

export default FactTable
